if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const productInfo = this.closest('product-info');
        const giftFields = productInfo && productInfo.querySelector('.gardenia-gift-fields');
        if (giftFields) {
          const cardField = giftFields.querySelector('[data-gardenia-gift-field="card"]');
          const recipientField = giftFields.querySelector('[data-gardenia-gift-field="recipient"]');
          const senderField = giftFields.querySelector('[data-gardenia-gift-field="sender"]');

          if (cardField) formData.set('properties[Card Message]', cardField.value);
          if (recipientField) formData.set('properties[Recipient Name]', recipientField.value);
          if (senderField) formData.set('properties[Sender Name]', senderField.value);
        }

        const selectedPaidCard = productInfo?.querySelector(
          '[data-gardenia-card-choice] [data-gardenia-card-option]:checked[data-card-variant-id]'
        );
        const paidCardVariantId = selectedPaidCard?.dataset.cardVariantId || '';
        const collectionChoice = productInfo?.querySelector('[data-gardenia-tree-collection-checkbox]:checked');
        const treeCollectionVariantId = collectionChoice?.dataset.gardeniaTreeCollectionVariantId || '';
        const selectedVaseChoice = productInfo?.querySelector('[data-gardenia-vase-addon] [data-gardenia-vase-choice]:checked[data-vase-variant-id]');
        const vaseVariantId = selectedVaseChoice?.dataset.vaseVariantId || '';
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        if (paidCardVariantId || treeCollectionVariantId || vaseVariantId) {
          const token = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
          const flowerProperties = {};

          formData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            if (!propertyMatch) return;
            if (value === '' || value === null || value === undefined) return;
            flowerProperties[propertyMatch[1]] = String(value);
          });

          if (paidCardVariantId) flowerProperties['_Gardenia card token'] = token;
          if (treeCollectionVariantId) flowerProperties['_Gardenia collection token'] = token;
          if (vaseVariantId) flowerProperties['_Gardenia vase token'] = token;

          const payload = {
            items: [
              {
                id: Number(variantId),
                quantity,
                properties: flowerProperties,
              },
              ...(paidCardVariantId ? [{
                id: Number(paidCardVariantId),
                quantity: 1,
                properties: {
                  '_Gardenia card add-on': 'true',
                  '_Gardenia card token': token,
                },
              }] : []),
              ...(treeCollectionVariantId ? [{
                id: Number(treeCollectionVariantId),
                quantity,
                properties: {
                  '_Gardenia January collection': 'true',
                  '_Gardenia collection token': token,
                  'Tree size': collectionChoice.dataset.gardeniaTreeCollectionTreeSize || '',
                  'Collection arrangement': 'Gardenia will contact you by return to arrange a January 2027 collection date',
                },
              }] : []),
              ...(vaseVariantId ? [{
                id: Number(vaseVariantId),
                quantity,
                properties: {
                  '_Gardenia vase add-on': 'true',
                  '_Gardenia vase token': token,
                },
              }] : []),
            ],
          };

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
            payload.sections_url = window.location.pathname + window.location.search;
          }

          config.headers['Content-Type'] = 'application/json';
          config.headers['Accept'] = 'application/json';
          config.body = JSON.stringify(payload);
        } else {
          delete config.headers['Content-Type'];

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname + window.location.search);
          }

          config.body = formData;
        }

        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if ((paidCardVariantId || treeCollectionVariantId || vaseVariantId) && Array.isArray(response.items) && response.items.length > 0) {
              response.id = Number(variantId);
              response.key = response.items[0]?.key || response.key;
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
